import type { FC } from "react";
import { Helmet } from "react-helmet-async";

type Props = {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
};

const SITE_URL = "https://our-wedding.duckdns.org";

const DEFAULT = {
  title: "Свадьба Валерия и Марии • 21 июня 2026",
  description:
    "Дорогой гость, мы рады пригласить вас разделить с нами самый важный день нашей жизни 💍 21 июня 2026, «Серая Шейка», а.г. Полыковичи",
  image: `${SITE_URL}/preview.png`,
  imageWidth: "1123",
  imageHeight: "1168",
  url: SITE_URL,
};

export const SEO: FC<Props> = ({
  title = DEFAULT.title,
  description = DEFAULT.description,
  image = DEFAULT.image,
  url = DEFAULT.url,
}) => {
  const apiKey = import.meta.env.VITE_YANDEX_MAPS_API_KEY;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="theme-color" content="#f0eddf" />
      <meta name="robots" content="noindex, nofollow" />

      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Свадьба Валерия и Марии" />
      <meta property="og:locale" content="ru_RU" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content={DEFAULT.imageWidth} />
      <meta property="og:image:height" content={DEFAULT.imageHeight} />
      <meta property="og:image:alt" content="Валера и Маша в детстве" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content="Валера и Маша в детстве" />

      {apiKey && (
        <script
          src={`https://api-maps.yandex.ru/v3/?apikey=${apiKey}&lang=ru_RU`}
          type="text/javascript"
          async
        />
      )}
    </Helmet>
  );
};
